// extracted by mini-css-extract-plugin
module.exports = {"entries":"ImageGallery_entries__1Qjf0","entryBoxContent":"ImageGallery_entryBoxContent__2Wfrq"};